<template>
	<o-section title="Ajout d'une nouvelle période d'indisponibilité">
		<o-datepicker
			v-model:range="setup.period"
			label="Période"
			type="range"
			required
			:min-date="new Date()"/>

		<br>

		<o-button
			color="success"
			block
			@click="setup.addUnavailabilityAsync()">
			Ajouter cette période
		</o-button>
	</o-section>
</template>

<script setup lang="ts">
import UserProfileUnavailabilityAsideNewSetupService from '@/setup/user-profile/UserProfileUnavailabilityAsideNewSetupService';
import { inject } from 'vue';
const _aside = inject<OrionAside>('_aside');
const props = defineProps(UserProfileUnavailabilityAsideNewSetupService.props);
const setup = new UserProfileUnavailabilityAsideNewSetupService(props, _aside);
</script>
